import React from 'react';
import { Badge } from '../../platformui';
import * as Render from '../../platformui/Base/Render';
import SemanticHeader from '../../platformui/Chapter/semantic-header';
import HighLight from '../../platformui/HighLight';

const RegionalContainer = (props) => {
  const blocksWithContent = Array.isArray(props.Content)
    ? [...props.Content]
    : [];

  for (let i = blocksWithContent.length - 1; i >= 0; i--) {
    const item = blocksWithContent[i];
    const shouldRemove = Object.entries(props.KeysWithContent)?.some(
      ([key, value]) => parseInt(key) === item.BlockId && !value
    );

    if (shouldRemove) {
      blocksWithContent.splice(i, 1);
    }
  }

  const hasOnlyHighlightBlock =
    blocksWithContent.length === 1 &&
    blocksWithContent[0].BlockTypeName === 'HighlightBlock';

  const baseHeadingLevel = props.headingLevel ?? 2;

  // Paragraph-style blocks move up one heading level (e.g from h3 to h2, but not above h2)
  const adjustedHeadingLevel =
    props.ShowAsItsOwnParagraph && baseHeadingLevel > 2
      ? baseHeadingLevel - 1
      : baseHeadingLevel;

  // Children (ChapterBlock) go one level deeper if we render a visible heading
  const childHeadingLevel = props.Heading
    ? adjustedHeadingLevel + 1
    : adjustedHeadingLevel;

  return (
    <>
      {hasOnlyHighlightBlock ? (
        <HighLight
          {...props}
          Heading={Render.Property(blocksWithContent[0]?.Heading, 'Heading')}
          ContentString={Render.PropertyAsHTML(
            blocksWithContent[0]?.ContentString,
            'Content'
          )}
          Buttons={blocksWithContent[0]?.Buttons}
          SelectedIcon={blocksWithContent[0]?.SelectedIcon}
          isInRegionalContainer
        />
      ) : (
        blocksWithContent.length > 0 && (
          <section
            className="regional-container"
            aria-labelledby={`ids-badge-${props.UniqueBlockId}`}
          >
            <Badge
              id={`ids-badge-${props.UniqueBlockId}`}
              type="secondary"
              text={`${props.CurrentPageProps?.Content?.Translations?.regionlabel} ${props?.RegionNames}`}
              srText={`Nedan innehåll gäller region ${props.CurrentRegionName}`}
            />
            <div
              className="regional-container__content"
              id={props.AnchorSectionId}
            >
              {props.Heading && (
                <SemanticHeader
                  customHeadingLevel={adjustedHeadingLevel}
                  className="regional-container__heading"
                >
                  {props.Heading}
                </SemanticHeader>
              )}
              <Render.Block
                blocks={blocksWithContent}
                propertyName="Content"
                currentPageProps={props.CurrentPageProps}
                regionalName={props.CurrentRegionName}
              >
                <Render.BlockTypeRenderer
                  Blocks={props.Blocks}
                  headingLevel={childHeadingLevel}
                  renderRegionAsExpandable={
                    !props?.Heading && props?.ShowAsItsOwnParagraph
                  }
                />
              </Render.Block>
            </div>
            <span className="show-for-sr">
              {`Slut på det regionala tillägget från region ${props.CurrentRegionName}`}
            </span>
          </section>
        )
      )}
    </>
  );
};

export default RegionalContainer;
